var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWallet4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 60C112 88.7189 88.7187 112 60 112C31.2813 112 8 88.7189 8 60C8 31.2813 31.2813 8 60 8C88.7187 8 112 31.2813 112 60Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0118 41.7187C49.9113 41.7187 41.7304 49.8996 41.7304 59.9998C41.7304 70.1003 49.9113 78.2812 60.0118 78.2812C69.0609 78.2812 76.5715 71.6847 78.0189 63.0468H96.4371C94.8832 81.8156 79.1765 96.5624 60.0118 96.5624C39.8261 96.5624 23.4492 80.1856 23.4492 59.9998C23.4492 39.8143 39.8261 23.4375 60.0118 23.4375C79.1765 23.4375 94.8832 38.1843 96.4371 56.9531H78.0035C76.5564 48.3152 69.0609 41.7187 60.0118 41.7187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet4);
export default __webpack_public_path__ + "static/media/icon-wallet-4.5d5b5c69711c617907c23243163e1a0f.svg";
export { ForwardRef as ReactComponent };